import type { FilmFact } from "@/types/content";

export const siteName = "色戒未删减版";

export const siteTagline = "电影资料 · 剧情解析 · 影评档案";

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "电影分类", to: "/category" },
  { label: "剧情解析", to: "/special/plot-analysis" },
  { label: "观影指南", to: "/guide" },
  { label: "关于我们", to: "/about" },
];

export const filmFacts: FilmFact[] = [
  { label: "上映年份", value: "2007" },
  { label: "导演", value: "李安" },
  { label: "主演", value: "梁朝伟 · 汤唯 · 王力宏" },
  { label: "片长", value: "完整版约 158 分钟" },
  { label: "类型", value: "剧情 / 爱情 / 悬疑" },
  { label: "语言", value: "普通话 · 粤语 · 上海话" },
];

export const siteStats = [
  { value: "158", unit: "分钟", label: "完整版片长参考" },
  { value: "11", unit: "篇", label: "深度资料与影评" },
  { value: "6", unit: "章", label: "剧情逐段解析" },
  { value: "4", unit: "类", label: "内容类型归档" },
];

export const footerLinks = [
  {
    title: "内容导航",
    links: [
      { label: "首页", to: "/" },
      { label: "电影分类", to: "/category" },
      { label: "剧情解析专题", to: "/special/plot-analysis" },
      { label: "观影指南", to: "/guide" },
    ],
  },
  {
    title: "资料归档",
    links: [
      { label: "完整版介绍", to: "/category?type=version" },
      { label: "影评与观点", to: "/category?type=review" },
      { label: "幕后与花絮", to: "/category?type=behind" },
      { label: "剧情解析", to: "/category?type=analysis" },
    ],
  },
  {
    title: "关于站点",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "联系方式", to: "/about#contact" },
      { label: "使用说明", to: "/about#usage" },
      { label: "版权声明", to: "/about#copyright" },
    ],
  },
];

export const friendLinks = [
  { label: "光影档案室", href: "https://zhanruihan.cn/archive" },
  { label: "老电影修复札记", href: "https://zhanruihan.cn/restore" },
  { label: "华语电影资料索引", href: "https://zhanruihan.cn/index" },
  { label: "影评人联合会", href: "https://zhanruihan.cn/critics" },
];

export const contactInfo = {
  email: "archive@sejie-demo.example.com",
  hours: "工作日 10:00 - 18:00（示例）",
  note: "本站为影视资料演示站点，不提供影片播放与下载。",
};